/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { SupportedSizeBaseDto } from "../../SupportedSizeBaseDto";

export class FrameSupportedSizeDto extends SupportedSizeBaseDto {
    frameId: string;
}
